import React, { Component } from 'react'

export default class CloseIcon extends Component{
	render(){
		return(
            <svg
                width="17px"
                height="17px"
                viewBox="0 0 17 17"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                style={{
                    verticalAlign: "middle"
                  , cursor: "pointer"
                  , position: "relative"
                  , left: "-12px"
                }}
                title="Asdasd"
            >
                <title>Group</title>
                <defs></defs>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                    <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
                        <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
                        <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
                    </g>
                </g>
            </svg>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/icons/CloseIcon.js